import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/site/PageHero";
import Reveal from "@/components/site/Reveal";
import { usePageMeta } from "@/components/site/SEO";
import { ASSETS } from "@/content/assets";

const PRINCIPLES = [
  { title: "Curiosity", text: "Every journey begins with a question your group genuinely wants to follow." },
  { title: "Place", text: "A coastline, a forest, a city: the setting shapes what there is to learn." },
  { title: "Pace", text: "Slow enough to notice, with room to pause, ask and wander." },
  { title: "Purpose", text: "Shaped around what matters to your group, from celebration to renewal." },
];

export default function Bespoke() {
  usePageMeta(
    "Bespoke Experiences",
    "Bespoke Experiences from Wandering Glider: a developing offering of custom journeys for families, individuals, private groups, adult groups and corporate groups.",
  );

  return (
    <>
      <PageHero
        eyebrow="Coming Soon"
        title="Bespoke Experiences"
        intro="A developing offering for families, individuals, private groups, adult groups and corporate groups who want to travel with curiosity."
      />

      <section className="container-x pb-20 sm:pb-28" data-testid="bespoke-body">
        <div className="grid gap-14 lg:grid-cols-2 lg:gap-20">
          <Reveal>
            <img
              src={ASSETS.bespokeImage.src}
              alt={ASSETS.bespokeImage.alt}
              loading="lazy"
              className="aspect-[4/3] w-full rounded-2xl object-cover"
            />
          </Reveal>
          <div className="flex flex-col justify-center">
            <Reveal>
              <p className="text-lg leading-relaxed text-ink/85">
                Bespoke Experiences grow from the same belief that shapes our school journeys: the
                world is our classroom, and it rewards those who wander through it with attention.
              </p>
              <p className="mt-6 text-lg leading-relaxed text-ink/85">
                Rather than fixed packages, we imagine each experience around a group's own
                curiosity, place, pace and purpose. This offering is still developing, and we are
                shaping it carefully rather than quickly.
              </p>
              <p className="mt-6 text-lg leading-relaxed text-ink/85">
                If you have an idea, an occasion or simply a question, we would love to hear it.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-20 grid gap-x-12 sm:grid-cols-2 lg:grid-cols-4">
          {PRINCIPLES.map((principle, i) => (
            <Reveal key={principle.title} delay={i * 0.06}>
              <div className="border-t border-line py-6">
                <h2 className="font-serif text-xl font-medium tracking-tight sm:text-2xl">
                  {principle.title}
                </h2>
                <p className="mt-3 text-base leading-relaxed text-ink/70">{principle.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-16">
            <Link
              to="/start-your-journey?journey=bespoke-experiences"
              data-testid="bespoke-conversation-cta"
              className="inline-flex items-center gap-2 bg-pine px-8 py-4 text-base font-medium text-canvas transition-colors duration-300 hover:bg-pinedeep"
            >
              Start a Conversation
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
          </div>
        </Reveal>
      </section>
    </>
  );
}
